var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.184 11.836-9.057-9.051-.607-.607a.739.739 0 0 0-1.04 0l-9.664 9.658a1.497 1.497 0 0 0-.44 1.079c.01.825.696 1.483 1.52 1.483h.997v7.634h16.214v-7.634h1.017a1.493 1.493 0 0 0 1.388-.928c.075-.182.113-.377.112-.574 0-.399-.157-.776-.44-1.06Zm-8.872 8.508h-2.624v-4.781h2.624v4.781Zm5.108-7.633v7.633h-3.608V15a.937.937 0 0 0-.937-.937h-3.75a.937.937 0 0 0-.937.937v5.344H5.58v-7.633H3.33l8.671-8.665.542.541 8.128 8.124H18.42Z"
  })));
};

export default SvgHouse;